import "styles/sections/reviews/ReviewsSection.scss";
import { MutableRefObject, memo } from "react";
import { HeadingDecoration, Section, SectionHeadline } from "components";
import { LangProp, Review, Section as SectionType, SliderData } from "types";
import { reviews } from "translations";
import Slider from "./Slider";

const star_w80 = "images-react/kenji/star_w80.png";
const star_w160 = "images-react/kenji/star_w160.png";

const ReviewsSection = memo(function ReviewsSection({
  lang,
  label,
  refer,
}: Props) {
  const reviewsData = reviews[lang] as SliderData<Review>;

  return (
    <div className="reviews-container">
      <Section className="reviews" label={label} refer={refer}>
        <SectionHeadline
          className="reviews__headline"
          decoration={
            <HeadingDecoration
              className="reviews__decoration"
              src={[
                { size: 80, src: star_w80 },
                { size: 160, src: star_w160 },
              ]}
            />
          }
        >
          {reviewsData.headline}
        </SectionHeadline>
        <Slider data={reviewsData} lang={lang} />
      </Section>
    </div>
  );
});

interface Props extends LangProp {
  label: SectionType;
  refer: MutableRefObject<HTMLHeadingElement | null>;
}

export default ReviewsSection;
